module.exports = __webpack_public_path__ + "img/wolf-darkMode.9a35b23d.svg";